<template>
  <div>
    <div class="theme-page-section theme-page-section-xl theme-page-section-gray">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="theme-payment-success-header">
              <i class="fa fa-exclamation-triangle theme-payment-partial-success-header-icon"></i>
              <h1 class="theme-payment-success-title">O pedido finalizado contém itens com erro na reserva</h1>
              <p class="theme-payment-success-subtitle">Verifique abaixo</p>
            </div>
          </div>
          <div class="col-md-4 col-md-offset-4">
            <div class="theme-payment-success">
              <div class="theme-payment-success-box">
                <ul class="theme-payment-success-summary">
                  <li>
                    Número do pedido
                    <span>{{ order.number }}</span>
                  </li>
                  <li>
                    Data
                    <span>{{ order.order_date|dateToHuman }}</span>
                  </li>
                  <li>
                    Valor pago em cartão de crédito
                    <span>{{ order.payment_creditcard|brlPrice }}</span>
                  </li>
                  <li>
                    Valor pago no check-in
                    <span>{{ order.payment_inloco|brlPrice }}</span>
                  </li>
                </ul>

                <div v-if="itemsError.length">
                  <p class="text-center color-magenta mt-30"><strong>Itens com erro</strong></p>
                  <table class="table table-sm">
                  <tbody>
                    <tr>
                      <td><strong>Produto</strong></td>
                      <td><strong>Código da reserva</strong></td>
                    </tr>
                    <tr v-for="(it, idx) in itemsError" :key="idx">
                      <td v-if="it.product">{{ it.product }}</td>
                      <td v-else>Item</td>
                      <td v-if="it.reservation_code">{{it.reservation_code }}</td>
                      <td v-else>000000</td>
                    </tr>
                  </tbody>
                </table>
                  </div>

                <p class="theme-payment-success-check-order">
                  Para consultar mais detalhes, acesse
                  <router-link :to="{name: 'orders'}">meus pedidos</router-link>
                </p>

                <!-- Debug rápido pra ver o JSON vindo do backend sem [object Object] -->
<!--                <pre v-if="order && Object.keys(order).length" class="theme-payment-success-debug">{{ orderDebug }}</pre>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      order: {}
    }
  },
  computed: {
    itemsError() {
      return Array.isArray(this.order && this.order.items_error)
        ? this.order.items_error
        : [];
    },
    orderDebug() {
      try {
        return JSON.stringify(this.order, null, 2);
      } catch (e) {
        return String(this.order);
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$http({
        url: '/api/reserve/success',
        method: 'get'
      }).then((response) => {
        let data = response.data;
        this.order = data;
      });
    },
    track() {
      this.$ga.page(
        {
          page: '/',
          title: 'Payment Success',
          location: window.location.href
        }
      )
    }
  }
};
</script>

<style scoped>
.theme-payment-success-header-icon {
  font-size: 70px;
  display: block;
  line-height: 1em;
  margin-bottom: 15px;
  color: #0093d2;
  text-shadow: 2px 5px 10px #9de1fe;
}

.theme-payment-success-debug {
  margin-top: 10px;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
  background: #f7f7f7;
  border: 1px solid #eee;
  padding: 10px;
  font-size: 12px;
}
</style>
